import { Image } from '@chakra-ui/react';

import logoMain from '@/assets/images/logo_main.png';

export const LivelinxLogo = () => <Image alt="Livelinx logo" src={logoMain} width="60px" />;
